module.exports = __webpack_public_path__ + "img/icon_other.02ab0c35.png";